module.exports = __webpack_public_path__ + "img/table-circle-equal.ecf5af4b.svg";